import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-setting-title",
  templateUrl: "./setting-title.component.html",
  styleUrls: ["./setting-title.component.scss"],
})
export class SettingTitleComponent implements OnInit {
  @Input() title: string;
  @Input() titleWithoutCase: string;

  constructor() {}

  ngOnInit(): void {}
}
